<div class="main-content">
  <div class="panel">
    <div class="panel-header">
      <button class="btn btn-sm btn-warning ms-auto" (click)="addPage()">
        Add New Page
      </button>
    </div>
    <div class="panel-body">
      <div class="table-responsive">
        <table class="table table-dashed table-hover digi-dataTable all-product-table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>Title</th>
              <th class="text-start" style="width: 350px;">Description</th>
              <th style="width: 150px;">Slug</th>
              <th class="position-sticky end-0 z-3" style="width: 100px;">Actions</th>
            </tr>
          </thead>
    
          <tbody>
            @for (page of pageList; track $index; let i = $index) {
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ page.title || '-' }}</td>
              <td class="text-start" [title]="getDescriptionPreview(page.description, 500)">
                <img
                  *ngIf="getDescriptionImage(page.description) as descriptionImage"
                  [src]="descriptionImage"
                  alt="Description image"
                  class="rounded mb-1 d-block"
                  style="width: 90px; height: 50px; object-fit: cover;"
                />
                <div>{{ getDescriptionPreview(page.description) }}</div>
              </td>
              <td>{{ page.slug || '-' }}</td>
    
    
    
              <!-- Actions -->
              <td  class="position-sticky end-0 z-3">
                <button type="button" class="btn text-success" (click)="editPage(page)"><i class="fa fa-pen"></i></button>
                <button type="button" class="btn text-danger" (click)="deletePage(i)"><i class="fa fa-trash"></i></button>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
</div>
